module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-640x1136.9d342a6a.png";